<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="4" style="text-align: start">

                <strong v-if="status_form==0">{{ $t('messages') }}</strong>
                <strong v-else>{{ $t('messages') }}</strong>

              </CCol>
              <CCol col="4" style="text-align: center ;">

                <strong v-if="status_form!=0">{{edit_name}}</strong>

              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton
                        v-if="items.filter(x=>x.docTypeId == selected_nature).length<3 && status_form ==0"
                         @click="insert_data()"
                         type="submit" size="sm" class="mr-1 ml-1"  color="secondary">
                  {{ $t('buttons.submit') }}
                </CButton>
                <CButton v-if="status_form !=0" @click="insert_data()"
                         type="submit" size="sm" color="secondary">
                  {{ $t('buttons.edit') }}
                </CButton>
                <CButton v-if="status_form!=0" @click="emptyList()"
                         class="mr-1"
                         type="reset" size="sm" color="secondary">
                  {{ $t("buttons.cancel") }}
                </CButton>

              </CCol>
            </CRow>
            <!--        </div>-->

            <!-- Right aligned nav items -->
            <!--      </CCollapse>-->
          </CCardHeader>

          <CCardBody ref="add_container">
            <CRow>
                <CCol col="3">
                  <CSelect
                          :label="$t('components.docType')"
                          :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"

                          :options="items_natures"
                          :value.sync="selected_nature"
                  />
                </CCol>
              <CCol col="8">
                <CTextarea
                    :label="$t('message')"
                    :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"
                    v-model="description"
:description="$t('max75char')"
                    rows="1"
                />


              </CCol>
            </CRow>
<!--            <label class="text-danger">{{$t('max3message')}}</label>-->
            <CDataTable
                :items="items_filtered"
                :fields="fields"
                column-filter
                style="height: 250px;overflow: auto"
                border
                striped
                @row-clicked="table_row_clicked"

                :items-per-page="20"
                hover
                sorter
                pagination
            >
              <template #row="{item,index}">

                <td style="text-align: center">
                  <p >{{ index +1}}</p>

                </td>

              </template>

              <template #color="{item}">

                <td>
                  <div :style="get_style(item.color)">
                    {{ item.color }}
                  </div>
                </td>

              </template>

              <template #docType="{item}">
                <td>
                  <p v-if="item.docTypeId==1">{{$t('buy')}}</p>
                  <p v-if="item.docTypeId==3">{{$t('sell')}}</p>
                  <p v-if="item.docTypeId==7">{{$t('buyFactorCurrency')}}</p>
                </td>
              </template>

              <template #operation="{item,index}">
                <td >
                  <a class="mr-1"
                           square
                           size="sm"
                           :title="$t('buttons.edit')"
                           @click="edit_item(item)"
                  >
                    <CIcon size="sm" class="text-warning" name="cil-pencil"/>
                  </a>

                  <CButton class="mr-1"

                           square
                           :title="$t('buttons.delete')"
                           size="sm"
                           @click="delete_item_dialog(item)"
                  >
                    <CIcon class="text-danger" size="sm" name="cilTrash"/>
                  </CButton>
                </td>
              </template>
            </CDataTable>
          </CCardBody>

        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

var items = [];


export default {
  name: 'Login',
  data() {
    return {
      confirm_delete_name:"confirm_category"+new Date().getTime()+"_"+this.$vnode.tag,
      name: '',
      edit_name: '',
      file: null,
      color: '#ffffff',
      code: '',
      items_natures: [],
      selected_nature: 3,
      previewImage: '/img/placeholder.png',
      description: '',
      items: [],
      items_filtered: [],
      table_clicks:0,
      table_clicks_timer:null,
      fields: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:5%'},
        {key: 'docType', label: this.$t('components.docType'), _style: 'width:10%'},
        {key: 'message', label: this.$t('message'), _style: 'width:25%'},
        // {key: 'natureTitle', label: this.$t('mainGroup'), _style: 'width:10%'},
        // {key: 'summary', label: this.$t('tables.summary'), _style: 'width:20%'},
        // {key: 'color', label: this.$t('tables.color'), _style: 'width:10%;'},
        // {key: 'image', label: this.$t('tables.image'), _style: 'width:10%;'},
        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:5%;'},


      ],
      details: [],
      collapseDuration: 0,
      status_form: 0
    }
  }, mounted() {
    this.$root.root_validate_errors = [];
    this.get_natures();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {

    'selected_nature': function () {
      this.items_filtered = this.items.filter(x=>x.docTypeId == this.selected_nature);
      // this.get_lists();
    }
  },
  methods: {
    get_natures() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.$route.params.cat_id);


      axios.post('message/GetData', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items_natures = [{label:self.$t('buy'),value:1},{label:self.$t('sell'),value:3},{label:self.$t('buyFactorCurrency'),value:7}]
           if(self.items_natures.length>0){
            // self.selected_nature = self.items_natures[0].value;
          }
           self.get_lists()
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
              .catch(function (error) {
                console.log(error);
              });

    },

    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.edit_item(item)
        this.table_clicks = 0

      }
    },
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.description != '') {
        return true;
      }

      // if (this.description == '') {
      //   this.$root.root_validate_errors.push(this.$t('dialogs.insertSummary'));
      // }
      return false;
      // e.preventDefault();
    },
    edit_item(item) {
      // this.$set(this.items[item.row_id], '_toggled', !item._toggled)
      // this.name = item.catTitle;
      // this.edit_name = item.catTitle;
      // this.color = item.color;
      // this.code = item.code;
      this.description = item.message;
      // this.selected_nature = item.natureId;
      // this.previewImage = this.$root.base_url +"/"+item.imageName;
      this.status_form = item.id;
      setTimeout(() =>
              this.$refs.add_container.scrollIntoView()
          , 500);
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },


    emptyList() {
      // this.$set(this.items[item.row_id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '/img/placeholder.png';
      this.status_form= 0;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    get_lists() {
      var self = this;

      const formData = new FormData();

      formData.append('DocTypeId', this.selected_nature);


      axios.post('message/GetData', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
          self.items_filtered = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
          self.items_filtered = self.items.filter(x=>x.docTypeId == self.selected_nature);

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });

    },

    insert_data() {


      if (!this.validateForm()) {
        // console.log("validate form is false"+this.validate_errors);
        return true;
      }

      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "message/Add";
      } else {
        url = "message/Update";
        formData.append('id', this.status_form)
      }

      formData.append('DocTypeId', this.selected_nature);
      formData.append('Message', this.description);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;
        self.description = '';

        self.get_lists();

      }).catch(function (error) {
            console.log(error);
          });

    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = item.id;

    }, delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "message/Delete";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);
        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {
            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
